import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FIELDS,
  LOADING,
  MODE,
  TOAST_MESSAGES,
} from "../../../constants/SiteConstants";
import AttributeForm from "./AttributeForm";
import useLoader from "../../../hooks/useLoader";

const API_URL = process.env.REACT_APP_API_URL;



const fetchAttributeById = async (id) => {
  try {
    const response = await axios.get(
      `${API_URL}/attribute/getAttributeById/${id}`
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};



const EditAttribute = () => {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const { loading, showLoader, hideLoader } = useLoader();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        showLoader();
        const response = await axios.get(`${API_URL}/productcategory/getAllproductcategories`);
        setCategories(response.data.data);
      } catch (error) {
        toast.error(TOAST_MESSAGES.ERROR_FETCHING_CATEGORIES, {
          autoClose: 1000,
        });
      } finally {
        hideLoader();
      }
    };

    fetchCategories();
  }, []);

  const fields = [
    {
      label: FIELDS.NAME,
      name: "name",
      placeholder: "Enter your name",
      required: true,
    },
    {
      label: "Category",
      name: "categoryId",
      required: true,
      type: "select",
      options: [
        { value: "", name: "Select Category" },
        ...(Array.isArray(categories)
          ? categories.map((category) => ({
              value: category._id, 
              name: category.name,
            }))
          : []),
      ],
    },
    {
      label: FIELDS.TYPE,
      name: "type",
      required: true,
      type: "select",
      placeholder: "status",
      options: [
        { value: MODE.TEXT, name: "Text" },
        { value: MODE.DROPDOWN, name: "Dropdown" },
      ],
    },
    
    {
      name: "status",
      type: "switch",
    },
  ];
  useEffect(() => {
    if (id) {
      const loadAttributeData = async () => {
        try {
          const data = await fetchAttributeById(id);

          if (data.type === "dropdown" && data.options) {
            setInitialData({ ...data, options: data.options });
          } else {
            setInitialData(data);
          }
        } catch (error) {
          toast.error("Failed to load attribute data");
        }
      };
      loadAttributeData();
    }
  }, [id]);

  const handleSubmit = async (formData) => {
    try {
      await axios.put(
        `${API_URL}/attribute/updateAttributeById/${id}`,
        formData
      );
      toast.success(TOAST_MESSAGES.DATA_UPDATED);
      navigate("/attribute");
    } catch (error) {
      toast.error(TOAST_MESSAGES.ERROR_UPDATE);
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update Attribute
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/attribute")}
        >
          &times;
        </button>
      </div>
      {initialData ? (
        <AttributeForm
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          initialData={initialData}
          selectedType={initialData.type}
        />
      ) : (
        <p>{LOADING}</p>
      )}
    </div>
  );
};

export default EditAttribute;
